import { createRoot, createElement } from '@wordpress/element';
import Dashboard from './pages/Dashboard';

import { DashboardProvider } from './context/DashboardContext';

import './styles/index.css';
import 'flowbite';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';

const container = document.getElementById('wholesale-dashboard');
const root = createRoot(container);
root.render(
    createElement(DashboardProvider, null, createElement(Dashboard))
);

setTimeout(() => {
    if (jQuery('body.folded').length === 0) {
        jQuery('#collapse-menu #collapse-button').trigger('click');
    }
}, 300);